import"./../jbTheme.css.ts.vanilla.css";import"./../jbBfcmTheme.css.ts.vanilla.css";import"./JbGlobalThemes.css.ts.vanilla.css";var s=function(){return null};export{s as default};
//# sourceMappingURL=JbGlobalThemes.js.map
